/**
 * <countdown-timer>
 *
 * Two honest modes only:
 *   fixed  one real end moment shared by every visitor
 *   daily  an order cut-off that genuinely repeats each day
 *
 * There is no per-visitor evergreen timer, because a countdown that restarts
 * for each person is a false claim about scarcity.
 *
 * Ticks once a second with setInterval and stops as soon as it reaches zero
 * or the element leaves the document.
 */
(function () {
  'use strict';

  if (customElements.get('countdown-timer')) return;

  const SECOND = 1000;
  const MINUTE = 60 * SECOND;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.display = this.querySelector('[data-countdown-display]');
      this.endedMessage = this.querySelector('[data-countdown-ended]');
      this.values = Array.from(this.querySelectorAll('[data-countdown-value]'));
      if (!this.display || this.values.length !== 4) return;

      this.target = this.resolveTarget();
      if (!this.target) {
        // Nothing to count to: leave the section as static content.
        this.display.hidden = true;
        return;
      }

      this.tick();
      this.timer = setInterval(() => this.tick(), SECOND);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    resolveTarget() {
      if (this.dataset.mode === 'daily') return this.nextDailyCutoff();

      const raw = this.dataset.target;
      if (!raw) return null;
      const date = new Date(raw);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    /** The next occurrence of HH:MM, today if it is still ahead. */
    nextDailyCutoff() {
      const [hours, minutes] = (this.dataset.dailyTime || '').split(':').map(Number);
      if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;

      const next = new Date();
      next.setHours(hours, minutes, 0, 0);
      if (next.getTime() <= Date.now()) next.setDate(next.getDate() + 1);
      return next;
    }

    tick() {
      const remaining = this.target.getTime() - Date.now();

      if (remaining <= 0) {
        clearInterval(this.timer);
        this.onEnd();
        return;
      }

      const parts = [
        Math.floor(remaining / DAY),
        Math.floor((remaining % DAY) / HOUR),
        Math.floor((remaining % HOUR) / MINUTE),
        Math.floor((remaining % MINUTE) / SECOND),
      ];

      parts.forEach((part, index) => {
        const text = index === 0 ? String(part) : String(part).padStart(2, '0');
        if (this.values[index].textContent !== text) this.values[index].textContent = text;
      });
    }

    onEnd() {
      if (this.dataset.onEnd === 'message' && this.endedMessage) {
        this.display.hidden = true;
        this.endedMessage.hidden = false;
        return;
      }

      // Hide the whole section rather than leave a dead row of zeroes.
      const section = this.closest('.shopify-section');
      if (section) section.hidden = true;
      else this.hidden = true;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
})();
